/**
 * StandardLayout
 * @module layouts/StandardLayout
 */

import React from 'react';
import { useAnchorLinkNavigation } from 'hooks';

import PageHeader from 'components/framework/PageHeader';
import PageFooter from 'components/framework/PageFooter';
import { useSiteType } from 'context/siteType.context';

interface StandardLayoutProps {
	children?: any;

	header?: object;

	api?: object;

	footer?: object;

	modelType?: string;
}

const StandardLayout: React.FC<StandardLayoutProps> = ({
	children,
	header,
	api,
	footer,
	modelType,
}) => {
	const siteType = useSiteType();
	useAnchorLinkNavigation();
	return (
		<div
			className={siteType === 'LindabGroup' ? 'bg-lgLightGrayBlue' : 'bg-beige'}
		>
			<PageHeader
				header={header}
				api={api}
				includeHeading={modelType === 'StartPage'}
				modelType={modelType}
			/>
			{children}
			{footer && <PageFooter footer={footer} className={''} />}
		</div>
	);
};

export default StandardLayout;
